import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const removeRoundByPlayerIdAtom = atom(
  null,
  (get, set, playerId: string) => {
    const booking = get(currentBookingAtom);
    if (!booking) {
      //@TODO: this is an error
      return;
    }

    const roundIndex = booking.rounds?.findIndex(
      (r) => r.player.id === playerId
    );

    if (roundIndex !== undefined && roundIndex !== -1) {
      const filteredRounds = booking.rounds
        ?.filter((_, index) => index !== roundIndex)
        .map((r, i) => ({
          ...r,
          index: i,
        }));

      set(currentBookingAtom, {
        ...booking,
        rounds: filteredRounds,
      });
    }
  }
);
